// extracted by mini-css-extract-plugin
export default {"wrapper":"MediaCard_wrapper__cAEOG","image":"MediaCard_image__dl+zm","content":"MediaCard_content__HQ6NJ","footer":"MediaCard_footer__Kp79N","wide":"MediaCard_wide__67VzC"};